<template>
  <pt-detection-list class="pt-detection-list__withData"></pt-detection-list>
</template>

<script>
import PtDetectionList from './index'
export default {
  name: 'pt-detection-list__withData',
  components: {
    'pt-detection-list': PtDetectionList
  }
}
</script>
